import styled, { css } from 'styled-components';
import Notification from './Notification';
import { colorSchema } from 'utils/style';
import { NOTIFICATION_TYPES } from 'utils/constants/notifications';

const typeProp = ({ type }) => {
  switch (type) {
    case NOTIFICATION_TYPES.INFO:
      return css`
        border-top: 2px solid ${colorSchema('primary300')};
      `;
    case NOTIFICATION_TYPES.SUCCESS:
      return css`
        border-top: 2px solid ${colorSchema('success700')};
      `;
    case NOTIFICATION_TYPES.WARNING:
      return css`
        border-top: 2px solid ${colorSchema('accent500')};
      `;
    case NOTIFICATION_TYPES.ERROR:
      return css`
        border-top: 2px solid ${colorSchema('error500')};
      `;
    case NOTIFICATION_TYPES.DEFAULT:
    default:
      return css`
        border-top: 2px solid ${colorSchema('primary')};
      `;
  }
};

export default styled(Notification)`
  .notification {
    ${typeProp}
    display: flex;
    position: relative;
    padding: 2.2rem 1.6rem;

    &__icon-container {
      display: flex;
      margin-right: 1.6rem;

      svg {
        fill: ${colorSchema('primary')};
      }

      &--success {
        svg {
          fill: ${colorSchema('success700')};
        }
      }

      &--warning {
        svg {
          fill: ${colorSchema('accent500')};
        }
      }

      &--error {
        svg {
          fill: ${colorSchema('error500')};
        }
      }

      &--info {
        svg {
          fill: ${colorSchema('primary300')};
        }
      }
    }

    &__body {
      display: flex;
      flex-direction: column;
      font-size: 1.5rem;
      height: 100%;
    }

    &__title {
      color: ${colorSchema('grey900')};
      font-weight: 500;
      font-size: 1.6rem;
      margin-bottom: 0.4rem;
    }

    &__content {
      display: flex;
    }

    &__text {
      color: ${colorSchema('grey700')};
      line-height: 1.31;
      font-size: 1.6rem;
    }

    &__link {
      background: none;
      border: 0;
      cursor: pointer;
      color: ${colorSchema('primary')};
      margin: 0;
      margin-left: 0.4rem;
      padding: 0;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;
